import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { Table } from "primeng/table";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { TitleCasePipe } from "@angular/common";
import { LazyLoadEvent } from "primeng/api";
import { Dropdown } from "primeng/dropdown";
import { environment } from "src/environments/environment";
import { saveAs } from "file-saver/src/FileSaver";
import { maxYearFunction } from "src/app/_helpers/utility";
import * as moment from "moment";
import { CategoryService } from "src/app/services/category.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { AcademypaymentService } from "src/app/services/academyPayment";
import { Lazy } from "swiper";
import { WindowRefService } from "src/app/services/window-ref.service";
import * as CryptoJS from "crypto-js";
import { AcademyService } from "src/app/manage/academies/service/academies.service";
import { nanoid } from "nanoid";
import { WalletService } from "src/app/services/wallet.service";
import { UserWalletRedemptionService } from "src/app/services/userWalletRedemption.service";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  FormsModule,
  FormArray,
} from "@angular/forms";
import { TreeNode } from "primeng/api";
import { TournamentsService } from "src/app/services/tournamnet.service";
import { filter } from "rxjs/operators";
import { UserService } from "src/app/services/user.service";
@Component({
  selector: "app-payment-section",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.scss"],
  styles: [
    `
      :host ::ng-deep .p-datatable-gridlines p-progressBar {
        width: 100%;
      }
      @media screen and (max-width: 960px) {
        :host
          ::ng-deep
          .p-datatable.p-datatable-customers.rowexpand-table
          .p-datatable-tbody
          > tr
          > td:nth-child(6) {
          display: flex;
        }
      }
    `,
  ],
  providers: [MessageService, ConfirmationService, TitleCasePipe],
})
export class AcademyFrontendPaymentListComponent implements OnInit {
  filtervisible: boolean = false;
  Withdrawmoney: boolean = false;
  transactiondate: any;
  transcst: any;
  errorMessage = "";
  statuses: any[];
  searchBy: any[];
  rowGroupMetadata: any;
  totalRecords: 0;
  virtualDatabase: any;
  academyPaymentList: any;
  userRoleId;
  userdetail: any;
  public item: any[] = [];
  loading: boolean;
  paginationOption;
  private tableLazyLoadEvent: LazyLoadEvent;
  calvalue: Date;
  ucalvalue: Date;
  dcalvalue: Date;
  yearRange;
  minYear = environment.minYear;
  startDate: Date;
  endDate: Date;
  downloadFlg: boolean;
  downloadAcademyPaymentsList: any;
  searchby;
  wdcalvalue;
  public hide: boolean = true;
  public catList: any[] = [];
  public brandList: any[] = [];
  public showFileUploadModal: boolean = false;
  public academyCsvFile;
  public uploadCsvFile: any[] = [];
  public academyImages: any[] = [];
  public uploadImageFiles: any[] = [];
  public showFileErrors: boolean = false;
  public showImageFileUploadModal: boolean = false;
  public showImageFileErrors: boolean = false;
  public academyId;
  public transvalue;
  public expiryvalue;
  public loggedInUser;
  public isLoggedIn: boolean = false;
  private key = CryptoJS.enc.Utf8.parse(environment.EncryptKey);
  private iv = CryptoJS.enc.Utf8.parse(environment.EncryptIV);
  public endUserId;
  public showAcademyRenewal: boolean = false;
  public showPlanModal: boolean = false;
  public membershipTypeList = environment.membershipTypeList;
  public selectedMembershipType;
  public showError: boolean = false;
  categoryList: any[] = [];
  mode;
  matchtypefilter;
  agegroupfilter;
  selectedGroupId;
  ageGroupList;
  playerdata;
  tournamentData;
  categoryfilter: FormGroup;
  showDefault: boolean = true;
  startDateTournament;
  endDateTournament;
  public courtTypeList = environment.courtTypeList;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  selectedAgeGroupId: any;
  playerRegister: boolean = true;
  private lastTableLazyLoadEvent: LazyLoadEvent;
  selectedStartDateRange: Date[];
  totalCount: 0;
  public drawStatus: boolean = false;
  profileDetails: any[];
  public kycDone: boolean;
  public userId;
  public kycApprove: boolean = false;
  withdrawList: any;
  totalWithdrawRecords: 0;
  constructor(
    private el: ElementRef,
    private academyPaymentService: AcademypaymentService,
    private titlecasePipe: TitleCasePipe,
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private categoryService: CategoryService,
    private tokenStorageService: TokenStorageService,
    private activeroute: ActivatedRoute,
    private winRef: WindowRefService,
    private academyService: AcademyService,
    private tournamentsService: TournamentsService,
    private walletService: WalletService,
    private userService: UserService,
    private userWalletRedemptionService: UserWalletRedemptionService,

  ) { }
  ngOnInit() {
    this.paginationOption = environment.pagination;
    // this.academyId = this.activeroute.snapshot.params.id;
    this.loggedInUser = this.tokenStorageService.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.isLoggedIn = true;
      if (this.loggedInUser.userdata["academyId"]) {
        this.endUserId = this.loggedInUser.userdata["id"];
        this.academyId = this.loggedInUser.userdata["academyId"];
      }
    }
    let academyPaymentDetails = this.loggedInUser.userdata.academyPaymentDetails;
    let roleName = this.loggedInUser.userdata.rolename;

    //let currentUrl = '/';
    this.showAcademyRenewal = false;
    if (roleName == "academy") {
      this.showAcademyRenewal = (academyPaymentDetails.academyPaymentStatus === "expire") ? true : false;
    }
    console.log(this.showAcademyRenewal);
    if (this.isLoggedIn == false) {
      this.router.navigate(['/']);
    }
    if (this.academyId == undefined) {
      this.router.navigate(['/']);
    }
    this.yearRange = this.minYear + ":" + maxYearFunction();
    this.statuses = [
      { label: 'Active', value: true },
      { label: 'In-Active', value: false }
    ];
    this.searchBy = [
      { label: 'Created On', value: "created_at" },
      { label: 'Last Modified On', value: "updated_at" }
    ];
    this.downloadFlg = false;
    this.membershipTypeList.forEach(element => {
      element['selected'] = false;
    })
    //this.getacademylist();
    this.getUserKycDetails(this.endUserId);
  }
  loadAcademyPayments(event: LazyLoadEvent) {
    this.tableLazyLoadEvent = event;
    let query = "?";
    let pagenumber = 1;
    let params = "";
    let rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }
    if (
      this.searchby != undefined &&
      this.startDate != undefined &&
      this.endDate != undefined
    ) {
      params += "&filterByDate=" + this.searchby.value;
      params +=
        "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    if (event.filters != undefined && event.filters["amount"] != undefined) {
      params += "&filterByAmount=" + event.filters["amount"].value;
    }
    if (event.filters != undefined && event.filters["status"] != undefined) {
      params += "&filterByStatus=" + event.filters["status"].value;
    }
    if (event.filters != undefined && event.filters["orderId"] != undefined) {
      params += "&filterByOrderId=" + event.filters["orderId"].value;
    }
    if (event.filters != undefined && event.filters["receiptId"] != undefined) {
      params += "&filterByReceiptId=" + event.filters["receiptId"].value;
    }
    if (event.filters != undefined && event.filters["paymentId"] != undefined) {
      params += "&filterByPaymentId=" + event.filters["paymentId"].value;
    }
    if (
      event.filters != undefined &&
      event.filters["transactionDate"] != undefined
    ) {
      const transactionDate = moment(
        event.filters["transactionDate"].value
      ).format("YYYY-MM-DD");
      params += "&filterByTransactionDate=" + transactionDate;
    }
    if (
      event.filters != undefined &&
      event.filters["expiryDate"] != undefined
    ) {
      const expiryDate = moment(event.filters["expiryDate"].value).format(
        "YYYY-MM-DD"
      );
      params += "&filterByExpiryDate=" + expiryDate;
    }
    if (
      event.filters != undefined &&
      event.filters["created_at"] != undefined
    ) {
      const createdAt = moment(event.filters["created_at"].value).format(
        "YYYY-MM-DD"
      );
      params += "&filterByCreatedAt=" + createdAt;
    }
    if (event.filters != undefined && event.filters["createdby"] != undefined) {
      params += "&filterByCreatedby=" + event.filters["createdby"].value;
    }
    if (
      event.filters != undefined &&
      event.filters["updated_at"] != undefined
    ) {
      const createdAt = moment(event.filters["updated_at"].value).format(
        "YYYY-MM-DD"
      );
      params += "&filterByUpdatedAt=" + createdAt;
    }
    if (event.filters != undefined && event.filters["updatedby"] != undefined) {
      params += "&filterByUpdatedby=" + event.filters["updatedby"].value;
    }
    params += "&filterByAcademyId=" + this.academyId;
    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }
    if (event.sortField != undefined && event.sortOrder != undefined) {
      let orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    /**
     * Sequence wise sort.
     **/
    // else {
    //     query += "&sortBy=getSequencewise" + "&orderBy=desc";
    // }
    this.academyPaymentService.getAcademyPaymentList(query).subscribe(
      (data) => {
        this.loading = false;
        if (data.data != undefined) {
          this.academyPaymentList = data.data.items;
          this.totalRecords = data.data.totalCount;
          this.academyPaymentList.forEach((element) => {
            if (element.status == "created") {
              this.showAcademyRenewal = false;
            }
          });
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  onClickRenewal() {
    this.showPlanModal = true;
  }
  onClickPlan(membership) {
    this.selectedMembershipType = membership.value;
    this.showError = false;
    this.membershipTypeList.forEach((element) => {
      if (element.value == this.selectedMembershipType) {
        let index = this.findIndexByValue(
          this.selectedMembershipType,
          this.membershipTypeList
        );
        if (index != -1) {
          this.membershipTypeList[index]["selected"] = true;
        }
      } else {
        element["selected"] = false;
      }
    });
  }
  isActive(type: string): boolean {
    return this.selectedMembershipType === type;
  }
  onClickResetPlan() {
    this.membershipTypeList.forEach((element) => {
      if (element.value == this.selectedMembershipType) {
        let index = this.findIndexByValue(
          this.selectedMembershipType,
          this.membershipTypeList
        );
        if (index != -1) {
          this.membershipTypeList[index]["selected"] = false;
        }
      }
    });
    this.selectedMembershipType = "";
    this.showError = false;
  }
  onClickPayNow() {
    let index = this.findIndexByValue(
      this.selectedMembershipType,
      this.membershipTypeList
    );
    this.showError = false;
    let membershipData;
    if (index != -1) {
      membershipData = this.membershipTypeList[index];
    } else {
      this.showError = true;
      return;
    }
    if (membershipData != undefined) {
      let dataObj = {};
      dataObj["academyId"] = this.academyId;
      dataObj["amount"] = membershipData.amount;
      dataObj["duration"] = membershipData.duration;
      dataObj["membershipType"] = this.selectedMembershipType;
      dataObj["endUserId"] = this.endUserId;
      this.academyPaymentService.addAcademyPayment(dataObj).subscribe(
        (data) => {
          this.showAcademyRenewal = false;
          let options: any = {
            key: environment.RAZORPAY_KEY_ID,
            amount: membershipData.amount * 100,
            currency: "INR",
            name: "TPL",
            description: "Academic Registration Payment",
            image: "../../../../assets/images/logo.png",
            order_id: data.data.orderId,
            modal: {
              escape: false,
              ondismiss: function () {
                window.location.reload();
              },
            },
            notes: {},
            theme: {
              color: "#0c238a",
            },
          };
          options.handler = (response, error) => {
            options.response = response;
            let verifyPaymentData = {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
            };
            this.academyPaymentService
              .verfiyAcademypayment(verifyPaymentData)
              .subscribe(async (paymentdata) => {
                //this.loadAcademyPayments(this.tableLazyLoadEvent);
                let endUserId = await this.encryptUsingAES256(this.endUserId);
                let paymentStatus = await this.encryptUsingAES256("successful");
                //let orderId = await this.encryptUsingAES256(id);
                let updatedData = {
                  payment_status: paymentStatus,
                  endUserId: endUserId,
                  orderId: data.data.orderId,
                  membership_name: this.selectedMembershipType
                };
                this.academyService
                  .updateAcademyStatus(this.academyId, updatedData)
                  .subscribe(
                    (data) => {
                      this.tokenStorageService.isLoggedOut();
                      this.router.navigateByUrl("/thank-you");
                      //this.showThankyouModal = true;
                    },
                    (err) => { }
                  );
              });
          };
          const rzp = new this.winRef.nativeWindow.Razorpay(options);
          rzp.open();
        },
        (error) => { }
      );
    }
  }
  findIndexByValue(value, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].value === value) {
        index = i;
        break;
      }
    }
    return index;
  }
  sendToPay(id) {
    var unpaidlist = this.academyPaymentList.find((x) => x.orderId == id);
    let options: any = {
      key: environment.RAZORPAY_KEY_ID,
      amount: unpaidlist.amount,
      currency: "INR",
      name: "TPL",
      description: "Academic Registration Payment",
      image: "../../../../assets/images/logo.png",
      order_id: id,
      modal: {
        escape: false,
      },
      notes: {},
      theme: {
        color: "#0c238a",
      },
    };
    options.handler = (response, error) => {
      options.response = response;
      let verifyPaymentData = {
        razorpay_payment_id: response.razorpay_payment_id,
        razorpay_order_id: response.razorpay_order_id,
        razorpay_signature: response.razorpay_signature,
      };
      this.academyPaymentService
        .verfiyAcademypayment(verifyPaymentData)
        .subscribe(async (paymentdata) => {
          //this.loadAcademyPayments(this.tableLazyLoadEvent);
          let endUserId = await this.encryptUsingAES256(this.endUserId);
          let paymentStatus = await this.encryptUsingAES256("successful");
          let orderId = await this.encryptUsingAES256(id);
          let updatedData = {
            payment_status: paymentStatus,
            endUserId: endUserId,
            orderId: orderId,
          };
          this.academyService
            .updateAcademyStatus(this.academyId, updatedData)
            .subscribe(
              (data) => {
                this.tokenStorageService.isLoggedOut();
                this.router.navigateByUrl("/thank-you");
              },
              (err) => { }
            );
        });
    };
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
  }
  async encryptUsingAES256(text): Promise<any> {
    var encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(text),
      this.key,
      {
        keySize: 128 / 8,
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return encrypted.toString();
  }
  func(prop, val) {
    let jsonStr = '{"' + prop + '":"' + val + '"}';
    return JSON.parse(jsonStr);
  }
  addNewAcademyPayment() {
    this.router.navigate(["/manage/academies/add"]);
  }
  viewAcademyPayment(id) {
    this.router.navigate(["/manage/academies/view/" + id]);
  }
  editAcademyPayment(id) {
    this.router.navigate(["/manage/academies/edit/" + id]);
  }
  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.academyPaymentList.length; i++) {
      if (this.academyPaymentList[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  }
  editmedia(id) {
    this.router.navigate(["manage/academies/media/" + id]);
  }
  // changeStatus(data) {
  //     this.confirmationService.confirm({
  //         message: 'Are you sure you want to change the status of  ' + (this.titlecasePipe.transform(data.name)) + '?',
  //         header: 'Confirm',
  //         icon: 'pi pi-exclamation-triangle',
  //         accept: () => {
  //             let updateData = '{"status":' + data.status + '}';
  //             this.academyPaymentService.updateAcademyPayment(data.id, updateData).subscribe(
  //                 data => {
  //                     this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Affiliate Status Updated', life: 3000 });
  //                     this.getUserDetails(data.id);
  //                 },
  //                 err => {
  //                     this.errorMessage = err.error.message;
  //                 }
  //             );
  //         },
  //         reject: () => {
  //             this.getUserDetails(data.id);
  //         }
  //     });
  // }
  showUploadModal() {
    this.showFileUploadModal = true;
  }
  showImageUploadModal() {
    this.showImageFileUploadModal = true;
  }
  // getUserDetails(id) {
  //     this.academyPaymentService.getAcademyPaymentDetails(id).subscribe(
  //         data => {
  //             this.userdetail = data;
  //             this.userdetail.created_at = new Date(this.userdetail.created_at);
  //             if (this.userdetail.status == true) {
  //                 this.userdetail.statusactive = true;
  //             } else {
  //                 this.userdetail.statusactive = false;
  //             }
  //             this.academyPaymentList[this.findIndexById(id)] = this.userdetail;
  //         },
  //         err => {
  //             this.errorMessage = err.error.message;
  //         }
  //     );
  // }
  setDownloadFlag() {
    this.downloadFlg = false;
  }
  exportExcel() {
    this.downloadFlg = true;
    this.loadAcademyPayments(this.tableLazyLoadEvent);
    let propertiesRemove = [
      "id",
      "created_at",
      "createdby",
      "updatedby",
      "disable",
      "updated_at",
      "categoryId",
      "status",
      "created_by",
      "Modification_Date",
      "invoiceFile",
    ];
    this.downloadAcademyPaymentsList = this.academyPaymentList;
    this.downloadAcademyPaymentsList.forEach(function (item) {
      if (item.transactionDate != "") {
        item["transactionDate"] = moment(item.transactionDate).format(
          "DD/MM/YYYY"
        );
      }
      if (item.expiryDate != "") {
        item["expiryDate"] = moment(item.expiryDate).format("DD/MM/YYYY");
      }
      if (item.amount != "") {
        item["amount"] = item.amount / Number(100);
      }
      propertiesRemove.forEach(function (prop) {
        delete item[prop];
      });
    });
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(
        this.downloadAcademyPaymentsList
      );
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "academy_payment");
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }
  /**
   * Use to add more columns in the table.
   */
  addColumns() {
    this.hide = false;
  }
  /**
   * Use to remove more columns in the table.
   */
  removeColumns() {
    this.hide = true;
  }
  academyPayment(id) {
    this.router.navigate(["/payments" + id]);
  }
  downloadPdf(invoiceFile) {
    window.open(invoiceFile);
  }
  onSelectCategory(event, id) {
    this.selectedGroupId = event.value.matchTypeId;
    let query = "getAgeGroup=true&matchtype=" + event.value.matchTypeId;
    this.tournamentsService.getTournamentCategory(id, query).subscribe(
      (data) => {
        if (data) {
          this.ageGroupList = data.items;
        }
      },
      (err) => { }
    );
  }
  onAgeGroupSelect(event, tournamentId) {
    this.selectedAgeGroupId = event.value.ageGroupId;
    this.drawStatus = event.value.drawStatus;
    this.getPlayerList(tournamentId);
  }
  getPlayerList(id) {
    this.playerdata = [];
    let query =
      "?matchTypeId=" +
      this.selectedGroupId +
      "&ageGroupId=" +
      this.selectedAgeGroupId;
    this.tournamentsService.getListOfPlayers(id, query).subscribe((data) => {
      this.playerdata = data.data.items;
      this.showDefault = false;
      if (this.playerdata.length < 1) {
        this.playerRegister = false;
      } else {
        this.playerRegister = true;
      }
    });
  }
  async getTournamentCategory(id) {
    this.playerdata = [];
    this.playerRegister = true;
    let query = "getMatchtype=true";
    this.tournamentsService.getTournamentCategory(id, query).subscribe(
      (data) => {
        if (data) {
          this.categoryList = data.items;
          this.showDefault = true;
        }
      },
      (err) => { }
    );
  }
  tournamentIncomeHistory(event: LazyLoadEvent) {
    let query = "filterByDisable=false";
    this.lastTableLazyLoadEvent = event;
    let first;
    let pagenumber = 1;
    let params = "";
    let rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }
    let second;
    if (
      this.startDateTournament != undefined &&
      this.endDateTournament != undefined
    ) {
      first = moment(this.startDateTournament).format("YYYY-MM-DD");
      second = moment(this.endDateTournament).format("YYYY-MM-DD");
      this.selectedStartDateRange = [first, second];
    }
    if (this.selectedStartDateRange != null) {
      params += "&filterByStartDateRange=" + this.selectedStartDateRange;
    }
    if (params != undefined && params != "") {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    } else {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
    }
    this.tournamentsService
      .tournamentIncomeHistory(this.academyId, query)
      .subscribe(
        (data) => {
          this.tournamentData = data.items;
          data.items.forEach((element) => {
            let tmp = this.courtTypeList.find(
              (o) => o.value === element.courttype
            );
            if (tmp != undefined) {
              element.court = tmp.label;
            } else {
              element.court = "";
            }
          });
          this.tournamentData.forEach(tElement => {
            let date = new Date();
            var startD = moment(date, 'DD-MM-YYYY').utc().toDate();//Date format should be "DD-MM-YYYY"
            var endD = moment(tElement.enddate, 'DD-MM-YYYY').utc().toDate();
            if (moment(startD).isAfter(moment(endD))) {
              tElement['isTournamentEnd'] = true;
            } else {
              tElement['isTournamentEnd'] = false;
            }
          });
          this.totalCount = data.totalCount;
        },
        (err) => {
          this.errorMessage = err.error.message;
        }
      );
  }
  clear() {
    this.startDateTournament = null;
    this.endDateTournament = null;
    this.selectedStartDateRange = [];
    this.tournamentIncomeHistory(this.lastTableLazyLoadEvent);
  }
  showFilter() {
    this.filtervisible = true;
  }
  async onClickWithdraw(data) {
    let tournamentId = await this.encryptUsingAES256(data._id);
    let tournamentAmount = await this.encryptUsingAES256(data.total);
    let tournamentData = [{
      tournamentId: tournamentId,
      tournamentAmount: tournamentAmount
    }];
    this.tokenStorageService.saveTournamentData(tournamentData);
    this.router.navigate(["/payment-redemption/" + this.endUserId]);
  }
  getUserKycDetails(userId) {
    this.userService.getUserDetails(userId).subscribe(
      data => {
        this.item = data;
        if (this.item) {
          this.profileDetails = this.item;
          var query = "?filterDisable=false&filterByuserId=" + userId;
          this.userService.getUserKycDetailsList(query).subscribe(
            (data) => {
              let totalRecords = data.items?.length;
              if (data.items.length > 0) {
                data.items.forEach(element => {
                  if (element.status === true) {
                    this.kycApprove = true;
                  }
                });
              }
              if (totalRecords < 1) {
                this.kycDone = false;
              } else {
                this.kycDone = true;
              }
            });
        }
      }, err => {
      });
  }
  loadWallet(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false&filterByAcademyId=" + this.academyId;
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }

    if (
      this.searchby != undefined &&
      this.startDate != undefined &&
      this.endDate != undefined
    ) {
      params += "&filterByDate=" + this.searchby.value;
      params +=
        "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    if (event.filters != undefined && event.filters["academyName"] != undefined) {
      params += "&filterByAcademyName=" + event.filters["academyName"].value;
    }
    if (event.filters != undefined && event.filters["tournamentName"] != undefined) {
      params += "&filterByTournamentName=" + event.filters["tournamentName"].value;
    }
    if (event.filters != undefined && event.filters["userName"] != undefined) {
      params += "&filterByname=" + event.filters["userName"].value;
    }
    if (
      event.filters != undefined &&
      event.filters["created_at"] != undefined
    ) {
      const created_at = moment(event.filters["created_at"].value).format(
        "YYYY-MM-DD"
      );
      params += "&filterByCreatedAt=" + created_at;
    }
    if (event.filters != undefined && event.filters["transferAmount"] != undefined) {
      params += "&filterByTransferAmmount=" + event.filters["transferAmount"].value;
    }
    if (event.filters != undefined && event.filters["tds"] != undefined) {
      params += "&filterByTds=" + event.filters["tds"].value;
    }
    if (event.filters != undefined && event.filters["commission"] != undefined) {
      params += "&filterByCommission=" + event.filters["commission"].value;
    }
    if (event.filters != undefined && event.filters["totalCreditedAmount"] != undefined) {
      params += "&filterByTotalCreditedAmount=" + event.filters["totalCreditedAmount"].value;
    }
    if (event.filters != undefined && event.filters["bankName"] != undefined) {
      params += "&filterByBankName=" + event.filters["bankName"].value;
    }
    if (event.filters != undefined && event.filters["accountNumber"] != undefined) {
      params += "&filterByAccountNumber=" + event.filters["accountNumber"].value;
    }
    if (event.filters != undefined && event.filters["status"] != undefined) {
      params += "&filterByStatus=" + event.filters["status"].value;
    }

    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.userWalletRedemptionService.getAcademyList(query).subscribe(
      (data) => {
        this.loading = false;
        this.withdrawList = data.data.items;
        this.totalWithdrawRecords = data.data.totalCount;
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

}
